import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import { getPreSaleOrderWarehouseProductStore } from '@/api/modules/warehouse-management/warehouseStore';

export const getDepositBillOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getDepositBillOrderList',
        data: data,
        method: 'post'
    });
};

export const getOldDepositBillOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getOldDepositBillOrderList',
        data: data,
        method: 'post'
    });
};

export const cancleDepositBillRecordByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/cancleDepositBillRecordByUuid',
        data: data,
        method: 'post'
    });
};

export const closeDepositBillRecordByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/closeDepositBillRecordByUuid',
        data: data,
        method: 'post'
    });
};

export const getDepositBillOrderDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getAppDepositBillInfo',
        data: data,
        method: 'post'
    });
};
export const getOriginalDepositBillInfo = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getOriginalDepositBillInfo',
        data: data,
        method: 'post'
    });
};

export const webIntentionGetOrderDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/webIntentionGetOrderDetail',
        data: data,
        method: 'post'
    });
};

export const updateIntentionCustomer = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/updateIntentionCustomer',
        data: data,
        method: 'post'
    });
};

export const updateIntention = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/updateIntention',
        data: data,
        method: 'post'
    });
};

export const deleteIntentionBillDetailByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/deleteIntentionBillDetail',
        data: data,
        method: 'post'
    });
};


export const getManagerList = data => {
    return axios.request({
        url: 'web/account/GetManagerList',
        data: data,
        method: 'post'
    });
};

export const getProductPromotionList = data => {
    return axios.request({
        url: 'api/productManagement/Promotion/getProductPromotionListByIntentionUuid',
        data: data,
        method: 'post'
    });
};

export const intentionRecordSubmitDeposit = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/intentionRecordSubmitDeposit',
        data: data,
        method: 'post'
    });
};

export const getPreDeliveryByDepositUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getPreDeliveryByDepositUuid',
        data: data,
        method: 'post'
    });
};

export const updateDepositBillDetailByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/updateDepositBillDetailByUuid',
        data: data,
        method: 'post'
    });
};

export const deleteDepositBillDetailByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/deleteDepositBillDetailByUuid',
        data: data,
        method: 'post'
    });
};

export const generatePreSaleDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/generatePreSaleDelivery',
        data: data,
        method: 'post'
    });
};

export const earlyTerminationDeposit = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/earlyTerminationDeposit',
        data: data,
        method: 'post'
    });
};


export const getNoPaidDepositBillOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getNoPaidDepositBillOrderList',
        data: data,
        method: 'post'
    });
};

export const getIntentionBillOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getIntentionBillOrderList',
        data: data,
        method: 'post'
    });
};

// 取消待支付定金单
export const cancelDepositBillByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/cancelDepositBillByUuid',
        data: data,
        method: 'post'
    });
};

// 打印定金单
export const printDepositBillRecord = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/printDepositBillRecord',
        data: data,
        method: 'post'
    });
};

export const getDepositBillInfoListByUuidArray = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getDepositBillInfoListByUuidArray',
        data: data,
        method: 'post'
    });
};

// 打印定金单
export const GetPreSalePlanBydepositBillRecordUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/GetPreSalePlanWeeksBydepositBillRecordUuid',
        data: data,
        method: 'post'
    });
};

export const SaveDepositBillRecordRemark = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/SaveDepositBillRecordRemark',
        data: data,
        method: 'post'
    });
};


//获取指点日期指定苗场有供货计划的产品列表
export const GetPreSalePlanWeeksSeedFarmAndDate = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/GetPreSalePlanWeeksSeedFarmAndDate',
        data: data,
        method: 'post'
    });
};
export const getContract = data => {
    return axios.request({
        url: 'web/combine/shopping/webGetContract',
        data: data,
        method: 'post'
    });
};

